
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24.438 24.438"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_15517","data-name":"Rectangle 15517","width":"24.438","height":"24.438","fill":"#6e60e3"}})])]),_c('g',{attrs:{"id":"Group_45931","data-name":"Group 45931"}},[_c('g',{attrs:{"id":"Group_45922","data-name":"Group 45922","clip-path":"url(#clip-path)","fill":"#6e60e3"}},[_c('path',{attrs:{"id":"Path_33062","data-name":"Path 33062","d":"M9.326 18.564H6.682A2.465 2.465 0 014.22 16.1V9.927a2.464 2.464 0 012.46-2.455h6.172a2.467 2.467 0 012.46 2.45v2.728a1.149 1.149 0 01-2.3 0V9.927a.161.161 0 00-.162-.156H6.682a.161.161 0 00-.163.16V16.1a.162.162 0 00.161.162h2.646a1.149 1.149 0 110 2.3","transform":"translate(-1.195 -.709)"}}),_c('path',{attrs:{"id":"Path_33063","data-name":"Path 33063","d":"M17.971 24.119H8.9a1.15 1.15 0 01-.984-1.746l4.53-7.473a1.15 1.15 0 011.965 0l4.542 7.471a1.15 1.15 0 01-.983 1.747m-7.033-2.3h4.99l-2.5-4.107z","transform":"translate(-.669 .318)"}}),_c('path',{attrs:{"id":"Path_33064","data-name":"Path 33064","d":"M16.968 12.364a1.149 1.149 0 01-.22-2.277 3.128 3.128 0 00-1.2-6.139 3.144 3.144 0 00-2.211 1.7 1.15 1.15 0 01-2.068-1.006 5.428 5.428 0 0110.203 1.33 5.428 5.428 0 01-4.281 6.37 1.134 1.134 0 01-.222.022","transform":"translate(-.161 -1.588)"}})])])])
          )
        }
      }
    